export class Disclaimer {
  public id?: number;
  public content?: string;
  public checked?: boolean;
  constructor() {
  }
}
